<template>
  <div class="dashboard reviews">
    <!-- Навбар -->
    <div class="navbar">
      <div class="left">
        <div class="title">
          <div class="wrap">
            <h4>Отчёты по отзывам</h4>
            <div class="sub-title">Аналитика и выгрузка данных</div>
          </div>
        </div>
        <TopBlock :no-data="true"></TopBlock>
      </div>
    </div>

    <!-- Блок фильтров и экспорта -->
    <div class="filters area report d-flex mb-3" v-if="project">
      <div class="filters-row">
        <!-- Выбор периода -->
        <div class="dates">
          <span class="label">Период с:</span>
          <div class="date">
            <date-picker
              v-model="date_from"
              locale="ru"
              :clearable="false"
              format="dd.MM.yyyy"
              model-type="yyyy-MM-dd"
              auto-apply
              :enable-time-picker="false"
            ></date-picker>
          </div>
          <span class="label">по:</span>
          <div class="date">
            <date-picker
              v-model="date_to"
              locale="ru"
              :clearable="false"
              format="dd.MM.yyyy"
              model-type="yyyy-MM-dd"
              auto-apply
              :enable-time-picker="false"
            ></date-picker>
          </div>
        </div>

        <div class="divider"></div>

        <!-- Объединённая кнопка экспорта -->
        <div class="export-group">
          <button class="btn btn-primary" @click="handleExport()" :disabled="report_request">
            <i class="bi bi-download"></i>
            {{ report_request ? 'Формирование...' : 'Экспорт' }}
          </button>
          <label class="full-report-checkbox">
            <input type="checkbox" v-model="export_full">
            <span class="checkmark"></span>
            <span class="label-text">Скачать все отзывы <span class="hint">(полный отчёт за весь период)</span></span>
          </label>
          <div class="export-hint">
            <i class="bi bi-info-circle"></i>
            <span v-if="!export_full">Будут выгружены отзывы за выбранный период</span>
            <span v-else>Будут выгружены все отзывы по проекту без ограничений по дате</span>
          </div>
        </div>
      </div>

      <!-- Отдельная кнопка динамики негатива -->
      <div class="divider vertical"></div>

      <div class="weekly-section">
        <div class="weekly-info">
          <i class="bi bi-bar-chart-line"></i>
          <span>Динамика негатива</span>
          <span class="hint">Анализ изменения негативных отзывов по дням</span>
        </div>
        <div :class="'weekly-btn-wrap' + (weekly_request ? ' loader' : '')">
          <a v-if="weekly_report" :href="weekly_report" target="_blank" class="btn btn-success">
            <i class="bi bi-filetype-xlsx"></i> Скачать отчёт
          </a>
          <a v-else href="" @click.prevent="getWeeklyReport" class="btn btn-outline-primary">
            <i class="bi bi-download"></i> Сформировать
          </a>
        </div>
      </div>
    </div>

    <!-- Список ранее сформированных отчётов -->
    <div class="reports-section">
      <div class="section-header">
        <h5><i class="bi bi-clock-history"></i> История отчётов</h5>
        <span class="badge">{{ objects.length }}</span>
      </div>

      <div class="table-flex-responsive">
        <div class="row header sticky">
          <div class="col-1">№</div>
          <div class="col-5">Период</div>
          <div class="col">Дата создания</div>
          <div class="col-3">Действие</div>
        </div>

        <template v-for="(object, index) in objects">
          <div class="row line">
            <div class="col-1 number">
              <div class="sub-head">№</div>
              {{ (index + 1) + ((page - 1) * size) }}
            </div>
            <div class="col-lg-5">
              <div class="sub-head">Период</div>
              {{ $moment(object.date_from).format("DD.MM.YY") }} — {{ $moment(object.date_to).format("DD.MM.YY") }}
            </div>
            <div class="col">
              <div class="sub-head">Дата создания</div>
              {{ $moment(object.date_create).format("DD.MM.YY HH:mm") }}
            </div>
            <div class="col-3">
              <button
                @click="getReport(object.id, `${project.name}-${$moment(object.date_from).format('DD.MM.YY')}-${$moment(object.date_to).format('DD.MM.YY')}.xlsx`)"
                class="btn btn-sm btn-dark"
              >
                <i class="bi bi-file-earmark-arrow-down"></i> Скачать
              </button>
            </div>
          </div>
        </template>

        <div v-if="!objects.length" class="empty-state">
          <i class="bi bi-inbox"></i>
          <p>Нет запрошенных отчётов</p>
          <span class="hint">Сформируйте новый отчёт с помощью кнопки «Экспорт»</span>
        </div>
      </div>

      <PagerList v-bind:pager="pager" v-bind:updatePage="updatePage" v-bind:page="page"></PagerList>
    </div>
  </div>
</template>

<script>
import dataMixin from '../mixins.js';
import TopBlock from "@/components/TopBlock.vue";
import {notify} from "@kyvg/vue3-notification";
import {ReportApi} from "@/api/report";
import moment from "moment";
import {state} from "@/socket";

export default {
  name: 'ReviewReports',
  components: {TopBlock},
  mixins: [dataMixin],
  data() {
    return {
      report_request: false,
      weekly_request: false,
      weekly_report: false,
      export_full: false, // Галочка для полного отчёта
      date_from: moment().subtract(1, 'month').format("YYYY-MM-DD"),
      date_to: moment().format("YYYY-MM-DD"),
    }
  },
  computed: {
    project: {
      get: function () {
        return this.$store.getters.currentProject;
      },
      set: function () {}
    },
    projectId: {
      get: function () {
        return this.$store.getters.currentProjectId;
      },
      set: function () {}
    },
    state_report(value) {
      return state.report
    },
  },
  watch: {
    state_report(value) {
      this.$notify({
        type: 'success',
        text: 'Отчёт готов'
      });
      this.objects.unshift(value);
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    updatePage(page) {
      this.page = page
    },
    fileResponse: function (response, name) {
      let blob = new Blob([response], {type: 'application/vnd.ms-excel'});
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = name;
      link.click();
    },
    getReport(id, file_name, type = "report") {
      ReportApi.protected_report_download(
        {id: id, type: type},
      ).then(response => {
        this.fileResponse(response.data, file_name)
      })
    },
    getData() {
      ReportApi.list(this.page).then(response => {
        this.objects = response.results;
        this.all_count = response.count
      })
    },
    getWeeklyReport() {
      this.weekly_request = true;
      ReportApi.weekly_report({project_id: this.projectId}).then(response => {
        this.$notify({
          type: 'success',
          text: 'Отчёт по динамике негатива готов'
        });
        this.weekly_request = false;
        this.getReport(this.project.id, `${this.project.name}-динамика_негатива.xlsx`, "project")
      }).catch(error => {
        this.$notify({
          type: "error",
          text: 'Ошибка создания отчёта'
        })
        this.weekly_request = false;
        console.error('Ошибка загрузки файла:', error);
      });
    },
    // Объединённая функция экспорта
    handleExport() {
      this.report_request = true;
      ReportApi.create({
        project_id: this.projectId,
        start: !this.export_full ? this.date_from : null,
        end: !this.export_full ? this.date_to : null,
        full: this.export_full,
      }).then(() => {
        notify({
          type: 'success',
          text: 'Отчёт отправлен на формирование'
        });
        this.report_request = false;
      }).catch(error => {
        notify({
          type: "error",
          text: 'Ошибка создания отчёта'
        })
        this.report_request = false;
        console.error('Ошибка загрузки файла:', error);
      });
    }
  }
}
</script>

<style scoped lang="scss">
// ===== Общие стили =====
.dashboard {
  padding: 20px;
}

.filters {
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  border: 1px solid #e9ecef;
  flex-wrap: wrap;
  gap: 20px;
  align-items: flex-start;
}

.filters-row {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  align-items: center;
  flex: 1;
}

// ===== Выбор дат =====
.dates {
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;

  .label {
    font-size: 13px;
    font-weight: 500;
    color: #495057;
  }

  .date {
    width: 150px;

    .dp__main {
      width: 100%;
    }

    :deep(.dp__input) {
      height: 38px;
      font-size: 13px;
      border-radius: 8px;
      border: 1px solid #dee2e6;
      background: #f8f9fa;
      transition: all 0.2s;

      &:focus {
        border-color: #6c5ce7;
        box-shadow: 0 0 0 3px rgba(108, 92, 231, 0.1);
        background: #fff;
      }
    }
  }
}

.divider {
  width: 1px;
  height: 40px;
  background: #e9ecef;
  margin: 0 8px;

  &.vertical {
    align-self: stretch;
  }
}

// ===== Группа экспорта =====
.export-group {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;

  .btn-primary {
    background: #6c5ce7;
    border: none;
    border-radius: 8px;
    padding: 8px 20px;
    font-weight: 500;
    font-size: 14px;
    transition: all 0.2s;
    height: 38px;
    display: flex;
    align-items: center;
    gap: 8px;

    &:hover {
      background: #5a4bd1;
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(108, 92, 231, 0.3);
    }

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
      transform: none;
    }
  }
}

.full-report-checkbox {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 13px;
  color: #495057;
  user-select: none;

  input[type="checkbox"] {
    appearance: none;
    width: 18px;
    height: 18px;
    border: 2px solid #dee2e6;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.2s;
    position: relative;
    flex-shrink: 0;

    &:checked {
      background: #6c5ce7;
      border-color: #6c5ce7;

      &::after {
        content: "✓";
        color: white;
        font-size: 13px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }

    &:hover {
      border-color: #6c5ce7;
    }
  }

  .label-text {
    display: flex;
    align-items: center;
    gap: 6px;

    .hint {
      font-size: 12px;
      color: #868e96;
      font-weight: 400;
    }
  }
}

.export-hint {
  font-size: 12px;
  color: #868e96;
  display: flex;
  align-items: center;
  gap: 4px;
  background: #f8f9fa;
  padding: 4px 12px;
  border-radius: 20px;

  i {
    font-size: 14px;
  }
}

// ===== Секция динамики негатива =====
.weekly-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 200px;
  background: #f8f9fa;
  padding: 12px 16px;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

.weekly-info {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 500;
  color: #212529;

  i {
    font-size: 18px;
    color: #6c5ce7;
  }

  .hint {
    font-weight: 400;
    font-size: 12px;
    color: #868e96;
  }
}

.weekly-btn-wrap {
  position: relative;
  min-height: 36px;

  .btn {
    border-radius: 8px;
    font-size: 13px;
    padding: 6px 16px;
    height: 36px;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    transition: all 0.2s;

    &-outline-primary {
      border-color: #6c5ce7;
      color: #6c5ce7;

      &:hover {
        background: #6c5ce7;
        color: white;
        transform: translateY(-1px);
      }
    }

    &-success {
      background: #20c997;
      border: none;
      color: white;

      &:hover {
        background: #1baa7e;
        transform: translateY(-1px);
      }
    }
  }

  &.loader {
    &:after {
      animation: spin 0.8s linear infinite;
      content: "";
      display: block;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 20px;
      height: 20px;
      border: 2px solid #6c5ce7;
      border-top-color: transparent;
      border-radius: 50%;
    }

    .btn {
      opacity: 0.3;
      pointer-events: none;
    }
  }
}

@keyframes spin {
  to { transform: translate(-50%, -50%) rotate(360deg); }
}

// ===== Секция истории =====
.reports-section {
  margin-top: 24px;
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  border: 1px solid #e9ecef;
}

.section-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;

  h5 {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 8px;

    i {
      color: #6c5ce7;
    }
  }

  .badge {
    background: #e9ecef;
    color: #495057;
    padding: 2px 10px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 500;
  }
}

// ===== Таблица =====
.table-flex-responsive {
  .row {
    display: flex;
    flex-wrap: wrap;
    padding: 12px 0;
    border-bottom: 1px solid #f1f3f5;
    align-items: center;

    &.header {
      font-weight: 600;
      font-size: 13px;
      color: #495057;
      background: #f8f9fa;
      border-radius: 8px;
      padding: 10px 0;
      border-bottom: none;
      margin-bottom: 4px;
    }

    &.line {
      transition: background 0.15s;

      &:hover {
        background: #faf9ff;
      }

      .col, .col-1, .col-3, .col-lg-5 {
        padding: 0 8px;
      }
    }

    .col, .col-1, .col-3, .col-lg-5 {
      padding: 0 8px;
    }

    .col-1 {
      flex: 0 0 8.333%;
      max-width: 8.333%;
    }
    .col-3 {
      flex: 0 0 25%;
      max-width: 25%;
    }
    .col-lg-5 {
      flex: 0 0 41.666%;
      max-width: 41.666%;
    }
  }

  .sub-head {
    display: none;
    font-size: 11px;
    font-weight: 600;
    color: #adb5bd;
    text-transform: uppercase;
    letter-spacing: 0.3px;
  }

  .number {
    font-weight: 500;
    color: #6c757d;
  }

  .btn-dark {
    background: #212529;
    border: none;
    border-radius: 6px;
    padding: 4px 14px;
    font-size: 12px;
    transition: all 0.2s;

    &:hover {
      background: #343a40;
      transform: translateY(-1px);
    }

    i {
      margin-right: 4px;
    }
  }
}

// ===== Пустое состояние =====
.empty-state {
  text-align: center;
  padding: 40px 20px;
  color: #868e96;

  i {
    font-size: 48px;
    color: #dee2e6;
    display: block;
    margin-bottom: 12px;
  }

  p {
    font-size: 16px;
    font-weight: 500;
    margin: 0;
    color: #495057;
  }

  .hint {
    font-size: 13px;
    color: #adb5bd;
  }
}

// ===== Адаптивность =====
@media (max-width: 992px) {
  .filters {
    flex-direction: column;
    align-items: stretch;
  }

  .filters-row {
    flex-direction: column;
    align-items: stretch;
  }

  .dates {
    width: 100%;
    justify-content: center;
  }

  .divider {
    display: none;
  }

  .export-group {
    flex-direction: column;
    align-items: stretch;
  }

  .weekly-section {
    width: 100%;
  }

  .table-flex-responsive .row {
    .col-1, .col-3, .col-lg-5 {
      flex: 0 0 100%;
      max-width: 100%;
      padding: 4px 8px;
    }

    .sub-head {
      display: inline-block;
      margin-right: 8px;
    }

    &.header {
      display: none;
    }
  }
}
</style>